/* Gussta: houdt de hele rechterkolom van de productpagina in beeld.
   Is de kolom hoger dan het scherm, dan schuift hij eerst mee tot zijn onderkant
   zichtbaar is en blijft hij daar staan (in plaats van bovenaan vast te plakken).
   Past de kolom wel in beeld, dan wordt de vrije ruimte verdeeld: 30% boven, 70% onder (Kevin, 4 nov 2026). */
(() => {
  const el = document.querySelector('.section-main-product .product__info-container.sticky-element');
  if (!el) return;
  const desktop = window.matchMedia('(min-width: 768px)');
  const MARGE = 20;
  let last = null;
  const update = () => {
    // De balk van Shopify onderin (alleen in een themavoorbeeld) mag de onderkant niet bedekken
    const balk = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    const onder = balk && balk.offsetHeight ? Math.max(0, window.innerHeight - balk.getBoundingClientRect().top) : 0;
    let value = '';
    let top = '';
    if (desktop.matches) {
      value = `${window.innerHeight - onder - el.offsetHeight - MARGE}px`;
      // Alleen een vastgepinde header telt mee. Niet de header die wegscrollt, anders verschuift de kolom tijdens het scrollen.
      const header = document.querySelector('header');
      const kop = header && document.body.classList.contains('header-pinned') ? header.offsetHeight : 0;
      const vrij = window.innerHeight - onder - kop - el.offsetHeight;
      if (vrij >= 2 * MARGE) top = `${Math.round(kop + Math.max(MARGE, vrij * 0.3))}px`;
    }
    const key = value + '|' + top;
    if (key === last) return;
    last = key;
    if (value) el.style.setProperty('--gp-sticky-room', value);
    else el.style.removeProperty('--gp-sticky-room');
    if (top) el.style.setProperty('--gp-sticky-top', top);
    else el.style.removeProperty('--gp-sticky-top');
  };
  // Blokken worden na het laden nog verplaatst en apps (Hulk, reviews) voegen later inhoud toe,
  // dus meten bij elke wijziging in de kolom, bij laden, schermwijziging en scrollen.
  new ResizeObserver(update).observe(el);
  new MutationObserver(update).observe(el, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
  window.addEventListener('scroll', update, { passive: true });
  desktop.addEventListener('change', update);
  update();
})();

/* Gussta: eigen keuzemenu voor de dropdowns van Hulk Product Options.
   De originele select blijft onzichtbaar staan; Hulk leest en valideert die gewoon. */
(() => {
  const section = document.querySelector('.section-main-product');
  if (!section) return;
  const CHEVRON = '<svg class="gp-select__chevron" viewBox="0 0 12 7" fill="none" aria-hidden="true"><path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CHECK = '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true"><path d="M1 5l4 4 8-8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  let teller = 0;

  const init = (select) => {
    if (select.dataset.gpMenu) return;
    select.dataset.gpMenu = '1';
    const id = `gp-select-${++teller}`;
    const wrap = document.createElement('div');
    wrap.className = 'gp-select';
    /* De select blijft direct onder zijn eigen ouder staan: Hulk valideert de verplichte keuzes
       via die plek. Met de select ín de wrapper keurde Hulk elke keuze af (4 nov 2026). */
    select.after(wrap);
    select.classList.add('gp-native');
    select.parentNode.classList.add('gp-select-host');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gp-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', id);
    /* Optienaam (bijv. Binnenmaat) staat in het veld zelf, klein boven de gekozen waarde */
    // Hulk-optie of een gewone Shopify-variantkeuze (variant-selects)
    const optie = select.closest('.hulkapps_option') || select.closest('.product-form__input');
    const naamEl = optie && optie.querySelector('.hulkapps_option_name, .form__label .font-body-bolder');
    const naam = naamEl ? naamEl.textContent.replace(/[*:]/g, '').trim() : '';
    if (naam) optie.classList.add('gp-label-in-veld');
    button.innerHTML = `<span class="gp-select__text"><span class="gp-select__label"></span><span class="gp-select__value"></span></span>${CHEVRON}`;
    button.querySelector('.gp-select__label').textContent = naam;
    const value = button.querySelector('.gp-select__value');

    const list = document.createElement('ul');
    list.className = 'gp-select__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;
    wrap.append(button, list);

    let items = [];
    let active = -1;

    const zichtbaar = (o) => o.value !== '' && !o.hidden && o.style.display !== 'none';
    const render = () => {
      items = [...select.options].filter(zichtbaar);
      list.innerHTML = '';
      items.forEach((o, i) => {
        const li = document.createElement('li');
        li.className = 'gp-select__option';
        li.id = `${id}-${i}`;
        li.setAttribute('role', 'option');
        if (o.disabled) li.setAttribute('aria-disabled', 'true');
        li.innerHTML = `<span></span>${CHECK}`;
        li.firstElementChild.textContent = o.textContent.trim();
        li.addEventListener('click', () => kies(i));
        li.addEventListener('mousemove', () => markeer(i));
        list.appendChild(li);
      });
      sync();
    };
    const sync = () => {
      const gekozen = select.options[select.selectedIndex];
      value.textContent = gekozen ? gekozen.textContent.trim() : '';
      const leeg = !gekozen || gekozen.value === '';
      wrap.dataset.empty = leeg ? 'true' : 'false';
      button.setAttribute('aria-label', naam ? (leeg ? value.textContent : `${naam}: ${value.textContent}`) : select.getAttribute('aria-label') || '');
      [...list.children].forEach((li, i) => li.setAttribute('aria-selected', items[i] === gekozen ? 'true' : 'false'));
    };
    const markeer = (i) => {
      active = i;
      [...list.children].forEach((li, n) => li.classList.toggle('is-active', n === i));
      const li = list.children[i];
      if (li) {
        list.setAttribute('aria-activedescendant', li.id);
        li.scrollIntoView({ block: 'nearest' });
      }
    };
    const open = () => {
      if (!list.hidden) return;
      document.querySelectorAll('.gp-select.is-open').forEach((w) => w !== wrap && w.dispatchEvent(new Event('gp-close')));
      list.hidden = false;
      wrap.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      const box = button.getBoundingClientRect();
      wrap.classList.toggle('gp-select--up', window.innerHeight - box.bottom < list.offsetHeight + 16 && box.top > window.innerHeight - box.bottom);
      const huidig = items.indexOf(select.options[select.selectedIndex]);
      markeer(huidig >= 0 ? huidig : 0);
      list.focus({ preventScroll: true });
    };
    const sluit = (focus) => {
      if (list.hidden) return;
      list.hidden = true;
      wrap.classList.remove('is-open', 'gp-select--up');
      button.setAttribute('aria-expanded', 'false');
      if (focus) button.focus();
    };
    const kies = (i) => {
      const o = items[i];
      if (!o || o.disabled) return;
      if (select.options[select.selectedIndex] !== o) {
        select.selectedIndex = [...select.options].indexOf(o);
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      sluit(true);
    };

    button.addEventListener('click', () => (list.hidden ? open() : sluit(true)));
    button.addEventListener('keydown', (e) => {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) {
        e.preventDefault();
        open();
      }
    });
    list.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') markeer(Math.min(active + 1, items.length - 1));
      else if (e.key === 'ArrowUp') markeer(Math.max(active - 1, 0));
      else if (e.key === 'Home') markeer(0);
      else if (e.key === 'End') markeer(items.length - 1);
      else if (e.key === 'Enter' || e.key === ' ') kies(active);
      else if (e.key === 'Escape') sluit(true);
      else if (e.key === 'Tab') return sluit(false);
      else return;
      e.preventDefault();
    });
    wrap.addEventListener('gp-close', () => sluit(false));
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) sluit(false);
    });
    select.addEventListener('change', sync);
    new MutationObserver(render).observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'style', 'selected'] });
    render();
  };

  const scan = () => section.querySelectorAll('select.hulk_po_dropdown, variant-selects select.form-control--select').forEach(init);
  new MutationObserver(scan).observe(section, { childList: true, subtree: true });
  scan();
})();
